import { FaFacebookF,FaPinterest,FaLinkedinIn,FaInstagram,FaYoutube } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6';
import Link from 'next/link'
 
const SocialMedia = props => (
    <>
        { props.customize ? <a className="myStrip__media rounded-circle d-block text-center mb-3 mr-3 text-white">{props.icon}</a>
        :<Link href={props.link}><a className="myStrip__media rounded-circle d-block text-center mb-3 mr-3 text-white" target="_blank">{props.icon}</a></Link>}
    </>
);

const Social = (props) => {
    let facebook = props.social.facebook_fanpage;
    let twitter = props.social.twitter;
    let pinterest = props.social.pinterest;
    let linkedin = props.social.linkedin;
    let instagram = props.social.instagram;
    let youtube = props.social.youtube;

return (
    <>
        { facebook ? <SocialMedia customize={props.customize} link={ "https://www.facebook.com/" + facebook } icon={<FaFacebookF/>}/> : null }
        { twitter ? <SocialMedia customize={props.customize} link={ "https://www.twitter.com/" + twitter } icon={<FaXTwitter/>}/> : null }
        { pinterest ? <SocialMedia customize={props.customize} link={ "https://www.pinterest.com/" + pinterest } icon={<FaPinterest/>}/> : null }
        { linkedin ? <SocialMedia customize={props.customize} link={ "https://www.linkedin.com/" + linkedin } icon={<FaLinkedinIn/>}/> : null }
        { instagram ? <SocialMedia customize={props.customize} link={ "https://www.instagram.com/" + instagram } icon={<FaInstagram/>}/> : null }
        { youtube ? <SocialMedia customize={props.customize} link={ "https://www.youtube.com/" + youtube } icon={<FaYoutube/>}/> : null }
    </>
);

}

export default Social;